import { User } from 'firebase/auth';
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { authFirebase } from '../../config/firebase';

type FirebaseContextType = {
    user: User | null;
};

const FirebaseContext = createContext<FirebaseContextType | undefined>(undefined);

export const FirebaseProvider: React.FC<React.PropsWithChildren<Record<string, unknown>>> = ({ children }) => {
    const [user, setUser] = useState<User | null>(null);
    const instanced = useRef(false);

    useEffect(() => {
        if (!instanced.current) {
            instanced.current = true;
            authFirebase.onAuthStateChanged((user: User | null) => {
                if (user) {
                    setUser(user);
                } else {
                    console.warn('Firebase user is null, user might be logged out or not authenticated.');
                    setUser(null);
                }
            });
        }
    }, []);

    return <FirebaseContext.Provider value={{ user }}>{children}</FirebaseContext.Provider>;
};

export const useProviderContext = () => {
    const context = useContext(FirebaseContext);
    if (!context) {
        throw new Error('useProviderContext must be used within a FirebaseProvider.');
    }

    return context;
};
